<template>
  <div class="d-block w-100">
    <v-row>
      <v-col cols="6">
        <v-select
          v-model="selectedCollection"
          :items="collections"
          item-title="collectionName"
          placeholder="Collectie"
          item-value="id"
          variant="solo"
          density="compact"
          hide-details
          required
          menu-icon="fal fa-chevron-down"
          :menu-props="{ class: 'kyano-menu' }"
        />
      </v-col>
      <v-col cols="6">
        <v-select
          v-if="selectedCollection"
          v-model="selectedField"
          :items="filteredFields"
          placeholder="Veld"
          item-title="title"
          item-value="column_name"
          variant="solo"
          density="compact"
          hide-details
          required
          menu-icon="fal fa-chevron-down"
          :menu-props="{ class: 'kyano-menu' }"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "FieldTypes",
    props: {
      modelValue: String,
      fields: Array,
    },
    emits: ["update:modelValue"],
    data() {
      return {
        selectedCollection: null,
        selectedField: null,
      };
    },
    computed: {
      collections() {
        return this.fields.map((col) => ({
          collectionName: col.collectionName,
          id: col.collection.id,
          fields: col.fields,
        }));
      },
      filteredFields() {
        const collection = this.collections.find((c) => c.id === this.selectedCollection);
        return collection ? collection.fields : [];
      },
    },
    watch: {
      selectedField(newVal) {
        const field = this.filteredFields.find((f) => f.column_name === newVal);
        if (field) {
          const payload = {
            collection_id: this.selectedCollection,
            column_name: field.column_name,
            field_type: field.field_type,
            label: field.title,
          };
          this.$emit("update:modelValue", payload);
        }
      },
    },
    methods: {},
  };
</script>

<style scoped>
  .collection-title {
    font-weight: bold;
    padding: 10px;
    font-size: 16px;
  }
</style>
